<script setup lang="ts">
  const {
    label,
    variant,
    size = "m",
    isBold = false,
  } = defineProps<{
    label: string;
    variant: "primary" | "success" | "warning" | "error" | "info";
    size?: "xs" | "s" | "m";
    isBold?: boolean;
  }>();
</script>

<template>
  <div class="badge" :class="[`badge--${variant}`, `badge--${size}`, { 'badge--bold': isBold }]">
    {{ label }}
  </div>
</template>

<style scoped>
  .badge {
    font-weight: 400;
    letter-spacing: 0.12px;
    padding: 8px 12px;
    border-radius: 8px;
    width: fit-content;
    font-family: Onest;
  }

  .badge--bold {
    font-weight: 600;
  }

  .badge--xs {
    padding: 2px 8px;
    font-size: 12px;
    line-height: 16px;
  }

  .badge--s {
    padding: 6px 10px;
    font-size: 14px;
    line-height: 18px;
  }

  .badge--m {
    padding: 8px 12px;
    font-size: 16px;
    line-height: 20px;
  }

  .badge--primary {
    background-color: var(--sf-base-background-secondary);
    color: var(--sf-base-text-secondary);
  }

  .badge--success {
    background-color: var(--sf-base-background-success);
    color: var(--sf-toast-text-success);
  }

  .badge--warning {
    background-color: var(--sf-base-background-warning);
    color: var(--sf-toast-text-warning);
  }

  .badge--error {
    background-color: var(--sf-base-background-error);
    color: var(--sf-toast-text-error);
  }

  .badge--info {
    background-color: var(--sf-base-background-info);
    color: var(--sf-toast-icon-background-info);
  }
</style>
